module.exports = "/images/gb-eng.svg?40dc3fae433516498a5fea6a5775f99b";